export enum DIR {
  ASC,
  DESC,
}

export class Sort {
  static sortString(a: string, b: string, order: DIR): number {
    const aLower = a.toLowerCase();
    const bLower = b.toLowerCase();
    return aLower.localeCompare(bLower) * (order === DIR.ASC ? 1 : -1);
  }
}
